const { jQuery: $ } = window;
import Utils from "./utils.class";

export default class MarketoValidator {
    static #tasks = [];
    static #mappings = {};

    constructor() {
        Utils.log("Registered: Marketo Validator");
    }

    static registerTask(name, callback, form) {
        form = form || "all";

        Utils.log("Registered validation function: " + name);

        if(!this.#mappings.hasOwnProperty(name)) {
            this.#mappings[name] = this.#tasks.length;
            this.#tasks.push({
                name: name,
                form: form,
                callback: callback,
                status: null
            });
        } else {
            throw new Error("Validation task already registered: " + name);
        }

    }

    static removeTask(name) {
        if(this.#mappings.hasOwnProperty(name)) {
            let i = this.#mappings[name];
            this.#tasks.splice(i, 1);
        } else {
            throw new Error("Attempted to delete non-existant validation task: " + name);
        }
    }

    static runTasks(form, success) {
        let anyFails = !success;

        for(let i in this.#tasks) {
            if(this.#tasks.hasOwnProperty(i)) {
                if(this.#tasks[i].form === 'all' || this.#tasks[i].form === form.getId() || this.#tasks[i].form.includes(form.getId())) {
                    Utils.log("Running Validation Task: ", this.#tasks[i].name);
                    this.#tasks[i].status = this.#tasks[i].callback.call(form, jQuery);

                    if(!this.#tasks[i].status) anyFails = true;

                    Utils.log("Task status: ", this.#tasks[i].status);
                }
            }
        }

        return !anyFails;
    }

    static getTaskStatus(name) {
        if(this.#mappings.hasOwnProperty(name)) {
            const i = this.#mappings[name];
            return this.#tasks[i].status;
        } else {
            throw new Error("Attempted to get status of non-existant validation task: " + name);
        }
    }

    static debugTasks() {
        Utils.log(this.#tasks);
    }
}

window.marketoValidator = MarketoValidator;